import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import backgroundImg from './assets/background.png';

// Убираем ВСЕ отступы и дырки
document.documentElement.style.margin = '0';
document.documentElement.style.padding = '0';
document.body.style.margin = '0';
document.body.style.padding = '0';

// Устанавливаем фон + темный оверлей
document.body.style.backgroundImage = `
  linear-gradient(rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.9)),
  url(${backgroundImg})
`; // 0.5 = 50% затемнение, можно менять от 0.1 до 0.9
document.body.style.backgroundRepeat = 'repeat-y';
document.body.style.backgroundSize = 'auto auto';
document.body.style.backgroundPosition = 'center top';
document.body.style.backgroundAttachment = 'scroll';

const root = ReactDOM.createRoot(
  document.getElementById('root')
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);